<template>
    <div v-if="show">
        <div class="product-detail">
            <div class="intro-container overflow">
                <div class="picture-container left">
                    <div class="top-img">
                        <div class="lg-img">
                            <img v-if="SelectedAttrImgUrl" :src="SelectedAttrImgUrl" alt="" />
                            <img v-else src="@/assets/images/default.png" alt="" />
                        </div>
                    </div>
                </div>
                <div class="attr-container left">
                    <el-form label-width="66px" ref="productDetailForm" :model="productForm">
                        <div class="name-container">
                            {{ productName }}
                        </div>
                        <div class="price-container">
                            <el-form-item :label="$t('createOrder.createOrder37')">
                                <el-input size="small" v-model="productForm.skuPrice"></el-input>
                            </el-form-item>
                        </div>
                        <div class="specification-container">
                            <div class="attr-row overflow" v-for="(item, index) in specificationList" :key="index">
                                <div class="title left" style="height: 30px; line-height: 30px">{{ item.name }}:</div>
                                <div :class="item2.checked == '1' ? 'attr-tag left attr-tag-checked' : 'attr-tag left attr-tag'"
                                    v-for="(item2, index2) in item.value" @click="tagClick(item2, item)" :key="index2">
                                    {{ item2.name }}
                                </div>
                            </div>
                        </div>
                        <div class="stock-container">
                            <el-form-item :label="$t('createOrder.createOrder38')">
                                <el-input-number controls-position="right" :min="1" v-model="productForm.quantity" @change="handleChange"
                                    size="small" onkeyup="this.value.replace(/\|D^0/g,'')"> </el-input-number>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="detail-container"></div>
        </div>
        <div class="flex-row flex-center">
            <el-button class="form-btn btn-gray" @click="goodsCancel">{{ $t('cancel') }}</el-button>
            <el-button class="form-btn btn-blue" @click="goodsSave">{{ $t('confirm') }}</el-button>
        </div>
    </div>
</template>
<script>
import {get1688Price} from "@/utils/utils";

export default {
    props: {
        subProps: {
            type: Object,
            default: () => { }
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        subProps: {
            handler(val) {
                console.log('-subProps', val)
                if (val?.url) {
                    this.initDom()
                }
            },
            immediate: true
        },
        visible(val) {
            if (!val) {
              this.show = false
            }
        }
    },
    data() {
        return {
            show: false,
            SelectedAttrImgUrl: undefined,
            specificationList: [],
            productForm: {
                skuPrice: '',
                quantity: '1'
            },
            pullSize: '',
            pullName: '',
            productName: '',
            /*商品sku表*/
            productArray: [],
            selectedSku: {},
            offerId: '',
            sellerOpenId : '',
            priceRangeList: [],
            detailObj: {},
        }
    },
    created() {
        console.log('create', this.subProps)
    },
    mounted() {

    },
    methods: {
        resetData() {
            this.specificationList = []
            this.productName = ''
            this.pullName = ''
            this.pullSize = ''
            this.productArray = []
            this.selectedSku = {}
            this.SelectedAttrImgUrl = undefined
            this.productForm = {
                skuPrice: '',
                quantity: '1'
            }
            this.offerId =  '';
            this.sellerOpenId =  '';
            this.priceRangeList = [];
            this.detailObj = {};
        },
        async initDom() {
            this.resetData()
            const { url, index } = this.subProps
            const res = await this.$http.get('order/getGoodsInfo', { params: { url: url } });
            const { data = {}, code, message } = res.data
            if (code === 200) {
                this.detailObj = data
                this.productName = data.title
                this.specificationList = data.specificationList;
                this.pullSize = this.specificationList.some((item) => item.colorFlag == 0)
                    ? this.specificationList.find((item) => item.colorFlag == 0).name
                    : this.specificationList.some((item) => item.colorFlag == 2)
                        ? this.specificationList.find((item) => item.colorFlag == 2).name
                        : '';
                this.pullName = this.specificationList.some((item) => item.colorFlag == 1)
                    ? this.specificationList.find((item) => item.colorFlag == 1).name
                    : this.specificationList.some((item) => item.colorFlag == 2)
                        ? this.specificationList.find((item) => item.colorFlag == 2).name
                        : '';
                this.specificationList.forEach((el) => {
                    el.value.forEach((el2) => {
                        this.$set(el2, 'checked', '0');
                    });
                });
                this.productArray = data.skuList;
                this.priceRangeList = data.priceRangeList;
                this.SelectedAttrImgUrl = data.picUrl
                if (!this.productArray || this.productArray.length ===0){
                  this.productForm.skuPrice = data.price
                }
                this.offerId = data?.offerId || ''
                this.sellerOpenId = data?.sellerOpenId || ''
                this.getSku();
                this.show = true
            } else {
                this.$emit('closeDialog')
                this.$message.error(message);
            }

        },
        goodsCancel() {
            this.$emit('update:visible', false)
        },
        // 商品信息保存
        async goodsSave() {
            const { row, index } = this.subProps
            if (!this.productForm.skuPrice || (this.specificationList.length && !this.selectedSku.price)) {
              this.$message.error(this.$t('createOrder.createOrder125'))
              return;
            }
            const goodsInfo = {
                ...row,
                goodsName: this.productName,
                goodsSize: this.selectedSku.sku_id && this.selectedSku.properties_name.some(item => item.name == this.pullSize) ? this.selectedSku.properties_name.find(item => item.name == this.pullSize).value : '',
                colour: this.selectedSku.sku_id && this.selectedSku.properties_name.some(item => item.name == this.pullName) ? this.selectedSku.properties_name.find(item => item.name == this.pullName).value : '',
                specId: this.selectedSku.specId ? this.selectedSku.specId : '',
                goodsCount: this.productForm.quantity,
                price: this.productForm.skuPrice,
                pictureUrl: this.SelectedAttrImgUrl,
                skuId: this.selectedSku.sku_id,
                offerId: this.offerId,
                sellerOpenId: this.sellerOpenId,
                priceRangeList: this.priceRangeList || []
            }
            // 处理1688零售价
            this.getNewPriceRangeList(goodsInfo)
            const res = await this.$http.post('shopping/vehicle/update', goodsInfo)
            const { data, code, message } = res.data
            if (code === 200) {
                console.log('data', data)
                this.$emit('onChange', index, data)
                this.$emit('update:subProps', {})
                this.$emit('update:visible', false)
            } else {
                this.$message.error(message)
            }
        },
        tagClick(item2, item) {
            if (item.colorcolorFlag == '1') {
                this.isInSmImg = 0;
            }
            item.value.forEach(function (el) {
                el.checked = '0';
            });
            item2.checked = '1';
            //选择颜色，左侧图片联动
            if (item2.url) {
                this.SelectedAttrImgUrl = item2.url;
            }
            this.getSku();
        },
        getSku() {
            let selectskuattrs = [];
            let attrCount = this.specificationList.length;
            if (!attrCount) {
              this.productForm.skuPrice = this.detailObj.price
              return;
            }
            let selectAttrCount = 0;
            this.specificationList.forEach(item => {
                item.value.forEach(item2 => {
                    if (item2.checked == '1') {
                        selectAttrCount++;
                        selectskuattrs.push({
                            name: item.name,
                            value: item2.name
                        });
                    }
                });
            });
          console.log(attrCount)
          console.log(selectAttrCount)
            if (attrCount == selectAttrCount) {

              //是否可选
               let isSelect = false
                this.productArray.forEach(item => {
                  let properties = [...item.properties_name]
                  let selectsku = [...selectskuattrs]
                  properties.sort((a, b) => a.name.localeCompare(b.name));
                  selectsku.sort((a, b) => a.name.localeCompare(b.name));
                  console.log(JSON.stringify(properties))
                  console.log(JSON.stringify(selectsku))
                  if (JSON.stringify(properties) === JSON.stringify(selectsku)) {
                    console.log(item)
                        this.selectedSku = item;
                        this.productForm.skuPrice = item.price;
                        isSelect = true
                        //_this.productForm.quantity = el.quantity;
                    }
                });

                if (isSelect) {
                  this.handleChange(this.productForm.quantity)
                }

               if (!isSelect){
                 this.selectedSku = {}
                 this.productForm.skuPrice = ''
               }
            }

        },
        handleChange(count) {
          if (!this.productForm.skuPrice && !this.selectedSku) return undefined
          // 赋值默认价格
          this.productForm.skuPrice = this.detailObj.price
          if (this.detailObj.platformType !== 1688) {
            // sku价格
            this.productForm.skuPrice = this.selectedSku?.price || this.productForm.skuPrice
            return
          }
          // 默认sku价格(如果有零售价格，否则使用商品价格)
          const defaultPrice1688 = this.selectedSku?.retailPrice || this.selectedSku?.price
          // 1688quoteType为1时固定使用sku价格
          this.productForm.skuPrice = this.detailObj.quoteType === 1 ? defaultPrice1688 : this.productForm.skuPrice
          if (this.priceRangeList?.length >= 1) {
            // 有区间价格时，根据数量匹配区间价格quoteType为1时固定使用sku价格
            const price = get1688Price(this.priceRangeList, count || 1)
            this.productForm.skuPrice = price ? (this.detailObj.quoteType === 1 ? this.selectedSku?.price : price) : (this.productForm.skuPrice || defaultPrice1688)
          }
        },
        getNewPriceRangeList(goodsInfo) {
          if (this.detailObj.platformType === 1688 && goodsInfo.priceRangeList?.length >= 1) {
            if (this.detailObj?.quoteType === 1) {
              goodsInfo.priceRangeList.forEach(item => {
                item.price = this.selectedSku?.price
              })
            }
            const defaultPrice1688 = this.selectedSku?.retailPrice || this.selectedSku?.price
            const price = this.detailObj?.quoteType === 1 ? defaultPrice1688 : this.detailObj.price
            if (goodsInfo.priceRangeList[0].startQuantity > 1) {
              goodsInfo.priceRangeList.unshift({ startQuantity: 1, price: price, promotionPrice: null })
            }
          }
        }
    },
}
</script>
<style scoped>
.product-detail {
    width: 100%;
    overflow: auto;
}

.picture-container {
    width: 40%;
    padding: 10px;
}

.attr-container {
    width: 60%;
    padding: 10px;
}

.price-container,
.specification-container,
.stock-container {
    margin-top: 20px;
}

.price-container .price,
.price-container .act-price {
    color: red;
    font-size: 30px;
}

.attr-row {
    margin-top: 15px;
}

.lg-img {
    width: 230px;
    height: 230px;
    margin: 0 auto;
}

.lg-img img {
    width: 230px;
    height: 230px;
}

.left {
    float: left;
}

.attr-tag-checked {
    border: 1px solid darkred;
    color: darkred;
}


.attr-tag {
    padding: 0 8px;
    border: 1px solid #ccc;
    cursor: pointer;
    margin-right: 5px;
    height: 30px;
    line-height: 30px;
    margin-top: 3px;
}


.overflow {
    overflow: hidden;
}

.attr-tag:hover {
    border: 1px solid darkred !important;
}
</style>
